import React from "react";
import { useTranslation } from "react-i18next";
import CartItemRow from "./CartItemRow";
import type { TransformedCartItem } from "../../types/cartApiTypes";

interface CartItemsListProps {
  items: TransformedCartItem[];
  isProcessing: boolean; // Combined loading state for update/remove
  onQuantityChange: (key: string, newQuantity: number) => void;
  onRemoveItem: (key: string) => void;
  currencySymbol: string; // Add currencySymbol prop
}

const CartItemsList: React.FC<CartItemsListProps> = ({
  items,
  isProcessing,
  onQuantityChange,
  onRemoveItem,
  currencySymbol, // Receive currencySymbol
}) => {
  const { t } = useTranslation();

  return (
    <div className="cart-items-list">
      {/* Header Row */}
      <div className="cart-item-header">
        <div className="item-thumbnail"></div> {/* Image column */}
        <div className="item-name">{t("cart.item.product", "Product")}</div>
        <div className="item-price">{t("cart.item.price", "Price")}</div>
        <div className="item-quantity">
          {t("cart.item.quantity", "Quantity")}
        </div>
        <div className="item-subtotal">
          {t("cart.item.subtotal", "Subtotal")}
        </div>
        <div className="item-remove"></div> {/* Remove button column */}
      </div>

      {/* Item Rows */}
      {items.map((item) => (
        <CartItemRow
          key={item.key}
          item={item}
          isProcessing={isProcessing}
          onQuantityChange={onQuantityChange}
          onRemoveItem={onRemoveItem}
          currencySymbol={currencySymbol} // Pass symbol down
        />
      ))}
    </div>
  );
};

export default CartItemsList;
